import { Box, Container, Paper, Stack } from "@mui/material";
import React, { useState } from "react";
// import logo from "../../assets/logo.png";
import { CheckEmail } from "./components/CheckEmail";
import { SendEmailForm } from "./components/SendEmailForm";
import { forgotPassword, getUserPool } from "../../services/api/apiClient";
import { forgotPasswordParams } from "../../services/api/types/auth/forgotPassword";
import { useCustomisation } from "../../context/CustomisationContext";
import { useToast } from "../../context/ToastContext";
import { FooterLogo } from "../components/FooterLogo";
import {
  UserEmailQueryParams,
  LoginFlow,
} from "../../services/api/types/auth/userPool";

interface ForgotPasswordProps {}

export const ForgotPassword: React.FC<ForgotPasswordProps> = () => {
  const [showCheckEmail, setShowCheckEmail] = useState(false);
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState<string>("");
  const { showToast } = useToast();
  const { customisations } = useCustomisation();
  const {
    LOGIN: {
      backgroundSettings: loginBgSettings,
      logoSettings: loginLogoSettings,
    },
    GPC: { backgroundSettings: gpcBgSettings, logoSettings: gpcLogoSettings },
  } = customisations.customisations;
  const primaryBgColor =
    loginBgSettings?.loginPrimaryBgColor ?? gpcBgSettings?.gpcPrimaryBgColor;
  const secondaryBgColor =
    loginBgSettings?.loginSecondaryBgColor ??
    gpcBgSettings?.gpcSecondaryBgColor;
  const logo =
    loginLogoSettings?.loginLandscapeLogo ?? gpcLogoSettings?.gpcLandscapeLogo;

  const sendEmail = async () => {
    try {
      setLoading(true);
      const emailQueryParams: UserEmailQueryParams = {
        email: email,
        loginFlow: LoginFlow.LOGIN,
        portalUrl: window.location.origin,
      };
      const userPoolResponse = await getUserPool(emailQueryParams);

      const body: forgotPasswordParams = {
        username: email,
        portalUrl: window.location.origin,
        clientId: userPoolResponse.clientId,
        portalId: userPoolResponse.portalId,
        userId: userPoolResponse.userId,
      };
      await forgotPassword(body);

      setShowCheckEmail(true);
    } catch (error: any) {
      console.log("Error:", error);
      showToast(error.response.data, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        alignItems: "center",
        py: 6,
        bgcolor: primaryBgColor,
      }}
    >
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          width: "100%",
        }}
      >
        <Container maxWidth="lg">
          <Stack alignItems="center" spacing={4}>
            <Paper
              elevation={1}
              sx={{
                maxWidth: 440,
                width: "100%",
                p: 4,
                borderRadius: 2,
                bgcolor: secondaryBgColor,
              }}
            >
              <Stack spacing={4} alignItems="center">
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: 50,
                    maxWidth: 200,
                  }}
                >
                  <Box
                    component="img"
                    src={`/${logo}`}
                    alt="logo"
                    sx={{
                      height: 50,
                      maxWidth: 200,
                      width: "auto",
                      objectFit: "contain",
                    }}
                  />
                </Box>
                {showCheckEmail ? (
                  <CheckEmail
                    sendEmail={sendEmail}
                    loading={loading}
                    email={email}
                  />
                ) : (
                  <SendEmailForm
                    sendEmail={sendEmail}
                    loading={loading}
                    email={email}
                    setEmail={setEmail}
                  />
                )}
              </Stack>
            </Paper>
          </Stack>
        </Container>
      </Box>
      {customisations.customisations.LOGIN.logoSettings?.loginPoweredBy?.toLowerCase() !==
      "true" ? (
        <FooterLogo />
      ) : null}
    </Box>
  );
};
